import { render, staticRenderFns } from "./AppCoreHeaderRight.vue?vue&type=template&id=4857bb08&"
import script from "./AppCoreHeaderRight.vue?vue&type=script&lang=js&"
export * from "./AppCoreHeaderRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AppCoreHeaderRight.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4857bb08')) {
      api.createRecord('4857bb08', component.options)
    } else {
      api.reload('4857bb08', component.options)
    }
    module.hot.accept("./AppCoreHeaderRight.vue?vue&type=template&id=4857bb08&", function () {
      api.rerender('4857bb08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ui/header/AppCoreHeaderRight.vue"
export default component.exports